import { Component, Inject, Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
@Injectable({ providedIn: 'root' })

export class AccessRequestService {

  baseUrl: string;
  constructor(private http: HttpClient) { }

  Addaccessrequest(firstname: string, lastname: string, emailid: string, comment: string) {
    this.baseUrl = environment.serviceUrl;
    let header = new HttpHeaders();
    let userrequest = 1;
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.http.post(this.baseUrl + 'api/UserApi/addrequest', { firstname, lastname, emailid, userrequest, comment }, { headers: header, observe: 'response' });
  }

}
